<template>
  <div class="simcard_profile">
    <div class="simcard_profile--header">
      <div class="count" v-if="count > 0">
        Всего - {{ count }}
      </div>
      <div class="description" v-if="description !== ''" v-html="description"></div>

    </div>
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th scope="col" class="icon_link">
              link
            </th>
            <th scope="col">
              status
            </th>
            <th scope="col">
              mno_name
            </th>

            <th scope="col">
              imsi
            </th>
            <th scope="col">
              iccid
            </th>
            <th scope="col">
              msisdn
            </th>
            <th scope="col">
              tariff
            </th>
            <th scope="col">
              ts_status_update
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="load" style="border:none; background-color:  transparent;">
            <td> <scale-loader /> </td>
          </tr>
          <router-link
              v-else
              :to="go_to(sim)"
              v-for="(sim,key) in simcards"
              :key="key"
          >
            <tr class="link">
              <td class="icon_link" data-label="link">
                <span @click.prevent="check_link(sim)" class="mdi mdi-sim"></span>
              </td>
              <td data-label="status">
              <span class="badge" :class="global_status_color(+sim.status)">
                {{ translate(global_status_text(+sim.status)) }}
              </span>
              </td>
              <td data-label="mno_name">{{ sim.mno_name }}</td>
              <td data-label="imsi">{{ sim.imsi }}</td>
              <td data-label="iccid">{{ sim.iccid }}</td>
              <td data-label="msisdn">{{ sim.msisdn }}</td>
              <td data-label="tariff">{{ tariffs[sim.tariff_id] }}</td>
              <td data-label="ts_status_update">{{ get_date(sim.ts_status_update) }}</td>
            </tr>
          </router-link>

        </tbody>
      </table>
    </div>

  </div>
</template>

<script>

export default {
  name: 'CommunicationManagementIndex',
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      load: true,
      simcards: [],
      tariffs: [],
      count: 0,
      description: ''
    }
  },

  methods: {
    check_link(sim){
      let params = {
        "msisdn": sim.msisdn,
        "iccid": sim.iccid,
        "imsi": sim.imsi
      }
      this.$http.v1.getSimcardImsi(params, (response) => {
        this.$router.push({path: '/simcard_devices/' + response.data.imsi})
      })
    },
    go_to (sim) {
      return {path: '/simcard_profile/' + sim.id}
    },
  },
  mounted () {
    let req = 'list'
    if (this.request === 'intersect') {
      req = 'list-intersect'
    }else if (this.request === 'not_use') {
      req = 'list-not-use'
    }else if (this.request === 'anothers') {
      req = 'list-anothers'
    }


  }
}
</script>
<style lang='scss' scoped>
  .simcard_profile{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    &--header{
      padding-top: 1vh;
      padding-left: 2vh;
      padding-right: 2vh;
      font-size: 14px;
    }
    .response_table{
      thead{
        flex: 0 1 0;
      }
      tbody{
        overflow-y: scroll;
        tr{
          transition: 0.2s;
          cursor: pointer;
          &:hover{
            background-color: #eee;
          }
        }
      }
      .icon_link{
        width: 50px;
      }
    }
  }
  .time_sync_simcard{
    cursor: pointer;
  }

  .link_simcard {
    cursor: pointer;
  }
 </style>
